<template>
  <div>
    <div v-for="group in menu" :key="group.title" class="menu-group">
      <h2 class="group-title">
        {{ group.title }}
      </h2>
      <ul>
        <li class="item-container" v-for="item in group.items" :key="item.name">
          <MenuItem :item="item" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import MenuItem from 'components/order/menu-item';
  import { mapState } from 'vuex';

  export default {
    name: 'MenuItems',
    components: { MenuItem },

    computed: {
      ...mapState('order', ['menu'])
    }

  };
</script>

<style lang="stylus" scoped>
  @require '~global/colors'
  @require '~global/typo'
  @require '~global/helpers'

  .menu-group
    margin-bottom: 5em

  .group-title
    @extend .t-subHeader
    margin-bottom: 2rem

  .item-container
    position: relative
    padding: .6rem 0
    &:before
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 1px;
      background-image: repeating-linear-gradient(
        to right,
        black 0 6px,
        transparent 6px 9px
      )

  .item-container:last-of-type
    &:after
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 1px;
      background-image: repeating-linear-gradient(
        to right,
        black 0 6px,
        transparent 6px 9px
      )
</style>
